module.exports = __webpack_public_path__ + "static/dashboard_screen_v1-dc464ed7b085ca33aaad8e1fadcddfee.png";